import { Location, NavigateFunction } from "react-router-dom";
import { CategoryData } from "./interface";
import { Routes } from "./Routes";

type NavigateCategoryOptions = {
  category: CategoryData;
  navigate: NavigateFunction;
  location: Location;
  showCreateCard?: boolean;
  categories?: (CategoryData & { shared?: number; received?: number })[];
  cardsViewPath?: string;
  navigationState?: Record<string, unknown>;
  get?: <T = unknown>(
    route: string,
    params?: Record<string, string | number>,
    query?: Record<string, string | number | boolean | undefined>
  ) => Promise<T>;
  probateDisplayName?: string;
};

export const navigateToDashboardCategory = async ({
  category,
  navigate,
  location,
  showCreateCard = false,
  categories = [],
  cardsViewPath = "/cards-view",
  navigationState,
  get,
  probateDisplayName,
}: NavigateCategoryOptions) => {
  if (showCreateCard) {
    if (!get) {
      throw new Error("Category template loader is required when creating a card.");
    }

    const templates = await get(
      Routes.GET_CARDTEMPLATE_By_Category,
      undefined,
      { categoryId: category.id_Category }
    );

    navigate(
      { pathname: cardsViewPath, search: location.search },
      {
        state: {
          ...(navigationState ?? {}),
          templates,
          category,
          showCreateCard,
          categories,
          probateDisplayName,
        },
      }
    );
    return;
  }

  navigate(
    { pathname: cardsViewPath, search: location.search },
    {
      state: {
        ...(navigationState ?? {}),
        category,
        showCreateCard: false,
        probateDisplayName,
      },
    }
  );
};
